import { Flex } from "@mantine/core";
import { ReactNode } from "react";

import { useStyles } from "./DocumentInfo.styles.tsx";

interface Props {
  children: ReactNode;
}

export const DocumentInfo = ({ children }: Props) => {
  const { classes } = useStyles();

  return (
    <Flex direction="column" className={classes.documentInfo}>
      {children}
    </Flex>
  );
};
